import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

import { getReferralCoupon } from 'store/referralCoupon';

import { Content } from 'components/Common';
import { Header, GetDiscount } from 'components';

export class GetDiscountContainer extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    referralCoupon: PropTypes.object
  };

  static defaultProps = {
    referralCoupon: null
  };

  render() {
    return (
      <div>
        <Header
          title={this.props.t('getDiscount.title')}
          description={this.props.t('getDiscount.description')}
        />

        <Content>
          <GetDiscount referralCoupon={this.props.referralCoupon} />
        </Content>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  referralCoupon: getReferralCoupon(state)
});

export default connect(mapStateToProps)(translate()(GetDiscountContainer));



// WEBPACK FOOTER //
// ./src/containers/GetDiscountContainer/GetDiscountContainer.js